(function () {
    'ngInject';

    angular.module('app.shared.services').factory('HttpService', httpService);

    function httpService($http, $location, $mdDialog, ConfigService) {
        function getConfig(method, url) {
            return {
                method: method,
                url: ConfigService.apiBaseURL + url,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                cache: false
            };
        }

        function get(url, contentType, configOverride = {}) {
            var config = getConfig('GET', url);
            config = {
                ...config,
                ...configOverride
            };
            if (contentType) {
                config.contentType = contentType;
            }
            return $http(config).then(function (response) {
                return response.data;
            }, onError);
        }

        function post(url, data, contentType) {
            var config = getConfig('POST', url);
            if (data) {
                config.data = data;
            }
            if (contentType) {
                config.contentType = contentType;
            }
            return $http(config).then(function (response) {
                return response.data;
            }, onError);
        }

        function del(url, contentType) {
            var config = getConfig('DELETE', url);
            if (contentType) {
                config.contentType = contentType;
            }
            return $http(config).then(function (response) {
                return response.data;
            }, onError);
        }

        function put(url, data, contentType) {
            var config = getConfig('PUT', url);
            if (data) {
                config.data = data;
            }
            if (contentType) {
                config.contentType = contentType;
            }
            return $http(config).then(function (response) {
                return response.data;
            }, onError);
        }

        function onError(reason) {
            const routesToExclude = ['/Users', 'Libraries'];

            // Internal server error
            if (reason.status == 500) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .title('Oops!')
                        .htmlContent(
                            reason.data.ExceptionMessage || reason.data.error || reason.data.Message || reason.data
                        )
                        .ok('OK')
                );
                console.error(reason.data.ExceptionMessage || reason.data.error || reason.data.Message || reason.data);
            } else if (reason.status == 401) {
                if (!ConfigService.openRoutes.includes(ConfigService.getCurrentOriginalPath())) {
                    $location.path('/signin');
                }
            } else if (reason.status == 400) {
                if (!routesToExclude.some((route) => reason.config.url.indexOf(route) > 0)) {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .title('Oops!')
                            .htmlContent(
                                (reason.data && reason.data.Message) ||
                                    (reason.data && reason.data.error) ||
                                    reason.data
                            )
                            .ok('OK')
                    );
                }
            } else if (reason.status == 403) {
                if (!routesToExclude.some((route) => reason.config.url.indexOf(route) > 0)) {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(false)
                            .title('Please check your credentials!')
                            .ok('close')
                    );
                }
            }

            throw reason;
        }

        return {
            get: get,
            post: post,
            delete: del,
            put: put
        };
    }
})();
